import { createConstants } from '../utils'

export default createConstants(
  'stopped', 
  'started', 
  'cleared'
)
